import { clomp } from 'clomp';

export const Form = clomp.form`
  flex
  flex-col
  w-full
`;
